exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loading-overlay[data-v-2d044d1f]{position:absolute;top:0;left:0;right:0;bottom:0;background:hsla(0,0%,100%,.7);display:flex;align-items:center;justify-content:center;z-index:5;backdrop-filter:blur(2px)}.loading-blur[data-v-2d044d1f]{filter:blur(1px);opacity:.6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2d044d1f","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/dashboard/VehiclePerformanceDashboard/components/DashboardChart.vue
// module id = 1471
// module chunks = 0